export default __webpack_public_path__ + "static/equipo-carlos-Color-Grande-2d140db9b2f5f0c059a323f07bbd213c.png";